/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Subject_Product_LotInputs */

const vi_print_admin_subject_product_lot = /** @type {(inputs: Print_Admin_Subject_Product_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô thành phẩm`)
};

/**

* @param {Print_Admin_Subject_Product_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_subject_product_lot = /** @type {((inputs?: Print_Admin_Subject_Product_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Subject_Product_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_subject_product_lot(inputs)
});